import { Component, OnInit, HostListener } from "@angular/core";
import { appConstants } from "src/app/constants/appConstants";
import { CommonService } from "src/app/services/common.service";
import { ToastrService } from "ngx-toastr";
import { Router } from "@angular/router";
import { AuthenticationService } from "src/app/services/authentication.service";

@Component({
  selector: "app-payment-initiate",
  templateUrl: "./payment-initiate.component.html",
  styleUrls: ["./payment-initiate.component.scss"],
})
export class PaymentInitiateComponent implements OnInit {
  constructor(
    private _commonService: CommonService,
    private _auththenticationService: AuthenticationService,
    private _toasterService: ToastrService,
    private _router: Router
  ) {}
  data_empty: boolean = false;
  showScroll: boolean;
  showScrollHeight = 300;
  hideScrollHeight = 10;
  reason: string = "";
  search: any = {
    phone: "",
  };
  pageLimit: number[] = [5, 10, 25, 50, 100];
  checkedBtn: any = [];
  page: number = 1;
  total_page: number = 1;
  pageSize: number = 50;
  selectedRequest: Array<any> = [];
  PaymentList: Array<any> = [];
  @HostListener("window:scroll")
  ngOnInit() {
    // this.getVerificationList(this.page - 1);
  }

  @HostListener("window:scroll", [])
  onWindowScroll() {
    if (
      (window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop) > this.showScrollHeight
    ) {
      this.showScroll = true;
    } else if (
      this.showScroll &&
      (window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop) < this.hideScrollHeight
    ) {
      this.showScroll = false;
    }
  }

  scrollToTop() {
    (function smoothscroll() {
      var currentScroll =
        document.documentElement.scrollTop || document.body.scrollTop;
      if (currentScroll > 0) {
        window.requestAnimationFrame(smoothscroll);
        window.scrollTo(0, currentScroll - currentScroll / 5);
      }
    })();
  }
  Search(key) {
    if (this.search.phone) {
      let url =
        appConstants.PAYMENT_INITIATE +
        this.search.phone +
        "?page=" +
        (this.page - 1) +
        "&pageSize=" +
        this.pageSize;

      this.getApiRequest(url);
    }
    //    ;
  }

  getVerificationList(page) {
    let url =
      appConstants.PAYMENT_INITIATE +
      this.search.phone +
      "?page=" +
      page +
      "&pageSize=" +
      this.pageSize;

    this.getApiRequest(url);
  }
  changePageSize() {
    this.getVerificationList(this.page - 1);
  }
  getApiRequest(url) {
    this._commonService.getRequest(url).subscribe(
      (res) => {
        this.PaymentList = res.paymentList;
        if (this.PaymentList.length === 0) {
          this.data_empty = true;
        }
        this.total_page = res.totalPage * this.pageSize;
      },
      (err) => {
        console.log("err", err);
      }
    );
  }
  showDetails(paymentId) {
    // this._router.navigate(["/Payment-details", paymentId]);
    this._auththenticationService
      .paymentDetail(paymentId, "Edit")
      .subscribe((res) => {
        if (res != true) {
        }
      });
  }
  getPageFromService(page) {
    if (page) {
      this.getVerificationList(page - 1);
    }
  }
}
